import type { SxProps, Theme } from "@mui/material";
import AthletesIcon from "components/Icons/AthletesIcon";
import CalendarIcon from "components/Icons/CalendarIcon";
import GroupsIcon from "components/Icons/GroupsIcon";
import { SortDataType } from "components/Tables/TableHeaderSortButton/TableHeaderSortButton";

type CellNames = "name" | "author" | "actions" | "updatedAt" | "scheduledFor";

interface TableHeaderCell {
  accessorKey: CellNames;
  header: string | null;
  sx?: SxProps<Theme>;
  startIcon?: React.ReactNode;
  sortDataType?: SortDataType;
  sortable: boolean;
}

const headerCells: TableHeaderCell[] = [
  {
    accessorKey: "name",
    header: "global.name_text",
    sx: { width: "max(100%, 240px)" },
    sortDataType: "text",
    sortable: true,
  },
  {
    accessorKey: "author",
    header: "global.author_label",
    sx: { width: "max(50%, 200px)" },
    startIcon: <AthletesIcon fontSize="small" />,
    sortDataType: "text",
    sortable: true,
  },
  {
    accessorKey: "updatedAt",
    header: "global.last_updated_label",
    sx: { width: "max(50%, 140px)", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" },
    startIcon: <CalendarIcon fontSize="small" />,
    sortDataType: "date",
    sortable: true,
  },
  {
    accessorKey: "scheduledFor",
    header: "global.scheduled_for_label",
    sx: { width: "max(70%, 200px)" },
    startIcon: <GroupsIcon fontSize="small" />,
    sortable: false,
  },
  {
    accessorKey: "actions",
    header: null,
    sx: { width: "100%", maxWidth: "56px" },
    sortable: false,
  },
] as const;

type DefaultSortKey = Extract<CellNames, "name" | "author" | "updatedAt">;

type ProgramsTableConfig = {
  headerCells: TableHeaderCell[];
  defaultSortKey: DefaultSortKey;
  defaultSortDirection: "asc" | "desc";
};

export const programsTableConfig: ProgramsTableConfig = {
  headerCells,
  defaultSortKey: "updatedAt",
  defaultSortDirection: "desc",
} as const;

type SortByType = {
  NAME: "name";
  CREATED_AT: "createdAt";
  UPDATED_AT: "updatedAt";
};

export const SortBy: SortByType = {
  NAME: "name",
  CREATED_AT: "createdAt",
  UPDATED_AT: "updatedAt",
} as const;

export const SortDirection = {
  ASC: "asc",
  DESC: "desc",
} as const;
